"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2["default"])(t); if (r) { var s = (0, _getPrototypeOf2["default"])(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2["default"])(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ImageZoomable = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ImageZoomable, _React$Component);
  var _super = _createSuper(ImageZoomable);
  function ImageZoomable(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ImageZoomable);
    _this = _super.call(this, props);
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.itemRef = /*#__PURE__*/_react["default"].createRef();
    _this.itemCopyRef = /*#__PURE__*/_react["default"].createRef();
    _this._onClick = _this._onClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this._onMouseMove = _this._onMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this._onMouseLeave = _this._onMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this._onMouseEnter = _this._onMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      isZooming: false
    };
    return _this;
  }
  (0, _createClass2["default"])(ImageZoomable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._containerSize = {
        width: this.containerRef.current.clientWidth,
        height: this.containerRef.current.clientHeight
      };
      this._itemSize = {
        width: this._containerSize.width,
        height: this._containerSize.height
      };
      // if (this.props.objectFit === "cover") {
      //     this._itemSize = {
      //         width: this._containerSize.width,
      //         height: this._containerSize.height
      //     };
      // } else if (this.props.mode === "contain") {
      //     // calculate container for contain.
      // }

      var zoom = this.props.zoom;
      this._maxMovementRange = {
        x: this._itemSize.width * (zoom - 1),
        y: this._itemSize.height * (zoom - 1)
      };

      // Touch
      // this.zoomer = new AbstractZoomer();
      //
      // this.zoomer.addEventListener("move", coords => {
      //     this.itemRef.current.style.transform = `translateX(${
      //         coords.x
      //         }px) translateY(${coords.y}px) scale(${coords.scale})`;
      // });
      //
      // this.zoomer.containerSize = {
      //     width: this.containerRef.current.clientWidth,
      //     height: this.containerRef.current.clientHeight
      // };
      //
      // if (this.props.mode === "natural" || this.props.mode === "cover") {
      //     this.zoomer.itemSize = {
      //         width: this.zoomer.containerSize.width,
      //         height: this.zoomer.containerSize.height
      //     };
      // }
    }
  }, {
    key: "_getMouseCoordinates",
    value: function _getMouseCoordinates(e) {
      this._mouseRelativeCoords = {
        x: e.nativeEvent.offsetX / this._itemSize.width,
        y: e.nativeEvent.offsetY / this._itemSize.height
      };
    }
  }, {
    key: "_calculateTransforms",
    value: function _calculateTransforms() {
      var zoom = this.props.zoom;
      return {
        transformX: -(this._mouseRelativeCoords.x - 0.5) * this._maxMovementRange.x / zoom,
        transformY: -(this._mouseRelativeCoords.y - 0.5) * this._maxMovementRange.y / zoom,
        scale: zoom
      };
    }
  }, {
    key: "_disableClickZoom",
    value: function _disableClickZoom() {
      var _this2 = this;
      this.setState({
        isDisappearing: true
      });
      this.disappearTimeout = setTimeout(function () {
        _this2.setState({
          isZooming: false,
          isDisappearing: false
        });
      }, 200);
    }
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      if (!this.state.isZooming) {
        if (this._mouseRelativeCoords === undefined) {
          this._getMouseCoordinates(e);
        }
        clearTimeout(this.disappearTimeout);
        this.setState(_objectSpread({
          isZooming: true,
          isDisappearing: false
        }, this._calculateTransforms()));
      } else {
        this._disableClickZoom();
      }
    }
  }, {
    key: "_onMouseMove",
    value: function _onMouseMove(e) {
      if (!this.props.cursorOverride) {
        this._getMouseCoordinates(e);
        if (this.state.isZooming) {
          this.setState(_objectSpread({}, this._calculateTransforms()));
        }
      }
    }
  }, {
    key: "_onMouseEnter",
    value: function _onMouseEnter() {
      clearTimeout(this.leaveTimeout);
    }
  }, {
    key: "_onMouseLeave",
    value: function _onMouseLeave() {
      var _this3 = this;
      this.leaveTimeout = setTimeout(function () {
        _this3._disableClickZoom();
      }, 200);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        zoom = _this$props.zoom,
        children = _this$props.children,
        cursorOverride = _this$props.cursorOverride;
      var transform = "scale(".concat(this.state.scale, ") translate(").concat(this.state.transformX, "px, ").concat(this.state.transformY, "px)");
      return __jsx(_Box["default"], {
        sx: {
          position: "relative",
          overflow: "hidden",
          cursor: cursorOverride ? "pointer" : this.state.isZooming ? "zoom-out" : "zoom-in"
        },
        ref: this.containerRef,
        onClick: this._onClick,
        onMouseMove: this._onMouseMove,
        onMouseLeave: this._onMouseLeave,
        onMouseEnter: this._onMouseEnter
      }, __jsx(_Box["default"], {
        ref: this.itemRef,
        sx: {
          transformOrigin: "50% 50%",
          transition: "none",
          height: "100%",
          width: "100%",
          minWidth: "inherit",
          minHeight: "inherit",
          maxWidth: "inherit",
          maxHeight: "inherit"
        },
        fitW: true,
        fitH: true
      }, children), this.state.isZooming && __jsx(_Box["default"], {
        ref: this.itemCopyRef,
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          minWidth: "inherit",
          minHeight: "inherit",
          maxWidth: "inherit",
          maxHeight: "inherit",
          transformOrigin: "50% 50%",
          transition: "opacity .2s",
          opacity: this.state.isDisappearing ? 0 : 1,
          transform: transform,
          pointerEvents: "none"
        },
        fitW: true,
        fitH: true
      }, children));
    }
  }]);
  return ImageZoomable;
}(_react["default"].Component);
ImageZoomable.defaultProps = {
  zoom: 2
};
var _default = ImageZoomable;
exports["default"] = _default;